import * as fromDatatype from '../datatype-library';

export interface bl_fi_deposit_txn_category_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    debit_side: boolean;
    credit_side: boolean;
    property_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_deposit_txn_category_line_RowClass implements bl_fi_deposit_txn_category_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    debit_side: boolean;
    credit_side: boolean;
    property_json: fromDatatype.JsonDatatypeInterface;
}
